<template>
    <div class="c-client-detail">
        <SphereNavigation color="blue" selected="client-search" />

        <div class="inner-content">
            <h1>{{$t('client_detail.title')}}</h1>

            <div class="action-btns">
                <button class="btn-basic blue" type="button" @click.prevent="showQR">
                    {{$t('client_detail.qrcode')}}
                </button>
                <button class="btn-basic blue" type="button" @click.prevent="showEmailForm">
                    {{$t('client_detail.search')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";

export default {
    name : "ClientDetail",
    components : {
        SphereNavigation
    },

    data() {
        return {
            intro: true
        };
    },

    methods: {
        showQR() {
            this.$router.push({name: "client-search-qr"});
        },

        showEmailForm() {
            this.$router.push({name: "client-search-form"});
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-detail {
        height : 100%;

        .inner-content {
            padding-left: 45%;
            padding-top : 3%;
        }

        .action-btns {
            .btn-basic {
                margin-right : 1rem;
            }

            @for $i from 1 through 5 {
                & > *:nth-child(#{$i}) {
                    @include slideIntroAnimation(basicSlideIntro, 450ms, #{250ms + $i * 250ms});
                }
            }
        }

    }
</style>